import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header__title" }, "Легенда", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 15L12 8L19 15",
    stroke: "#0F172A",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { class: "dw-legends__container" }
const _hoisted_5 = { class: "container__legends" }
const _hoisted_6 = { class: "legends__legend" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Доставка", -1)
const _hoisted_8 = { class: "legends__legend" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Доставка опаздывает", -1)
const _hoisted_10 = { class: "legends__legend" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Доставка в ЛО", -1)
const _hoisted_12 = { class: "legends__legend" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Доставка осуществлена", -1)
const _hoisted_14 = { class: "legends__legend" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Невыданная доставка", -1)
const _hoisted_16 = { class: "legends__legend" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Забор", -1)
const _hoisted_18 = { class: "legends__legend" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Забор опаздывает", -1)
const _hoisted_20 = { class: "legends__legend" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Забор в ЛО", -1)
const _hoisted_22 = { class: "legends__legend" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Забор осуществлен", -1)
const _hoisted_24 = { class: "legends__legend" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "container__text" }, "Неназначенный забор", -1)
const _hoisted_26 = { class: "container__sectors" }
const _hoisted_27 = {
  key: 0,
  class: "sectors__state"
}
const _hoisted_28 = {
  key: 1,
  class: "sectors__container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_static_record_marker = _resolveComponent("dw-static-record-marker")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dw-legends", { 'dw-legends--opened': _ctx.state.is_opened }]),
    style: _normalizeStyle({ marginLeft: _ctx.sidebarOpened ? '300px' : '56px' })
  }, [
    _createElementVNode("div", {
      class: "dw-legends__header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_dw_static_record_marker, { type: 2 }),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_dw_static_record_marker, {
            delaying: "",
            type: 2
          }),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_dw_static_record_marker, {
            "wait-list-status": "1",
            type: 2
          }),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_dw_static_record_marker, {
            state: 1,
            type: 2
          }),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_dw_static_record_marker, {
            "not-delivered": "",
            type: 2
          }),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_dw_static_record_marker, { type: 1 }),
          _hoisted_17
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_dw_static_record_marker, {
            delaying: "",
            type: 1
          }),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_dw_static_record_marker, {
            "wait-list-status": "1",
            type: 1
          }),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_dw_static_record_marker, {
            state: 1,
            type: 1
          }),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_dw_static_record_marker, {
            "not-assigned": "",
            type: 1
          }),
          _hoisted_25
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_ctx.sectorsLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors, (sector) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sector.id,
                  class: "sectors__sector"
                }, [
                  _createTextVNode(" Сектор "),
                  _createElementVNode("span", {
                    class: "sector__name",
                    style: _normalizeStyle({ color: sector.color })
                  }, _toDisplayString(sector.name), 5)
                ]))
              }), 128))
            ]))
      ])
    ])
  ], 6))
}